import { Typography } from "@mui/material"
import Box from "@mui/material/Box"
import Slider from "@mui/material/Slider"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const MAX_TIME_MS = 1000 * 60 * 10 // 10 minutos

export default function ReservationTimer() {
  const { t } = useTranslation()
  const [value, setValue] = useState<number>(MAX_TIME_MS)

  useEffect(() => {
    if (value <= 0) {
      window.location.reload()
      return
    }

    const interval = setInterval(() => {
      setValue((prev) => Math.max(0, prev - 1000))
    }, 1000)

    return () => clearInterval(interval)
  }, [value])

  const formatMinutes = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}:${seconds.toString().padStart(2, "0")}`
  }

  return (
    <Box sx={{ width: "100%", mt: 2, px: 1 }}>
      <Typography
        variant="body2"
        sx={{
          mt: 1,
          fontWeight: 600,
          color:
            (value / MAX_TIME_MS) * 100 <= 10
              ? "error.main"
              : (value / MAX_TIME_MS) * 100 <= 30
              ? "warning.main"
              : "text.primary",
        }}
        gutterBottom
      >
        {value < 60000
          ? t("ticket.reservationExpiring")
          : t("ticket.reservationRemaining")}
      </Typography>
      <Slider
        aria-label={t("ticket.reservationAria")}
        value={value}
        max={MAX_TIME_MS}
        step={1000}
        valueLabelDisplay="on"
        valueLabelFormat={formatMinutes}
        disabled
        sx={{
          mt: 3.5,
          "&.Mui-disabled": {
            color:
              (value / MAX_TIME_MS) * 100 <= 10
                ? "error.main"
                : (value / MAX_TIME_MS) * 100 <= 30
                ? "warning.main"
                : "primary.main",
          },
          "& .MuiSlider-track": {
            opacity: 1,
          },
          "& .MuiSlider-rail": {
            opacity: 0.3,
          },
          "& .MuiSlider-thumb": {
            //display: "none", // opcional
          },
        }}
      />
    </Box>
  )
}
